module.exports = __webpack_public_path__ + "img/sobremesas.c94e688e.svg";